import { useEffect, useState, useRef, useCallback } from 'react';

export default function useStickyMenu(
  mainMenuId = 'header-main-content',
  housingMenuId = 'housing-project-menu',
  warningBlockId = 'global-warning-block'
) {
  const [maxScrollHeight, setMaxScrollHeight] = useState(0);
  const [hideMenu, setHideMenu] = useState(false);
  const [openMainMenu, setOpenMainMenu] = useState(false);
  const prevScrollPosRef = useRef(0);

  const calculateOffset = () => {
    if (typeof document !== 'undefined') {
      const mainMenu = document.getElementById(mainMenuId);
      const housingMenu = document.getElementById(housingMenuId);

      if (housingMenu) {
        let varOffset = 0;
        const warningBlock = document.getElementById(warningBlockId);
        if (warningBlock) {
          if (sessionStorage) {
            const isViewed = sessionStorage.getItem('global-warning-closed');

            if (!isViewed) {
              varOffset += warningBlock.getBoundingClientRect().height;
            }
          }
        }
        if (mainMenu) {
          varOffset += mainMenu.getBoundingClientRect().height;
        }

        document.documentElement.style.setProperty(
          '--header-offset',
          `${varOffset}px`
        );

        setMaxScrollHeight(varOffset);
      }
    }
  };

  const handleScroll = useCallback(() => {
    if (typeof window !== 'undefined') {
      const currentScrollPos = window.scrollY;
      const scrollDelta = currentScrollPos - prevScrollPosRef.current;

      if (!openMainMenu) {
        setHideMenu(scrollDelta > 0);

        document.documentElement.style.setProperty(
          '--scroll-pos',
          `${currentScrollPos}px`
        );
      }

      prevScrollPosRef.current = currentScrollPos;
    }
  }, [maxScrollHeight, openMainMenu]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  useEffect(() => {
    calculateOffset();
    window.addEventListener('resize', calculateOffset, { passive: true });

    return () => {
      window.removeEventListener('resize', calculateOffset);
    };
  }, [calculateOffset]);

  return {
    calculateOffset,
    hideMenu,
    setHideMenu,
    openMainMenu,
    setOpenMainMenu
  };
}
